<div *ngIf="loading" class="loader-container">
  <app-loader variant="almostready"></app-loader>
</div>

<div *ngIf="error" class="error-container">
  <p>{{ error }}</p>
  <button mat-raised-button color="primary" (click)="back.emit()">
    {{ "results.common.goBack" | translate }}
  </button>
</div>

<div *ngIf="!loading && !error && stats" class="wrap">
  <div class="head">
    <ng-content select="[shell-header]"></ng-content>
  </div>

  <div class="stat-strip">
    <div class="stat-item">
      <strong>{{ "results.stats.started" | translate }}</strong>
      <span>{{ stats.startDate }}</span>
    </div>
    <div class="stat-item">
      <strong>{{ "results.stats.thisCheck" | translate }}</strong>
      <span>{{ stats.checkDate }}</span>
    </div>
    <div class="stat-item">
      <strong>{{ "results.stats.checks" | translate }}</strong>
      <span>{{ stats.checkCount }}</span>
    </div>
    <div class="stat-item">
      <strong>{{ "results.stats.sinceLast" | translate }}</strong>
      <span>{{
        stats.daysSinceLast > 0 ? stats.daysSinceLast + "d" : "\u2013"
      }}</span>
    </div>
  </div>

  <ng-content select="[shell-after-stats]"></ng-content>
  <ng-content></ng-content>

  <div class="note">{{ "results.common.insightsNote" | translate }}</div>
</div>
